module.exports = __webpack_public_path__ + "img/img3.2e0cd2d6.jpg";